import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface CreateEmployeeEducationParams {
	company_id: string;
	name: string;
}

const Service = PsychosocialReportService.getInstance();

export const useCreateEmployeeEducation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: CreateEmployeeEducationParams) => Service.createEmployeeEducation(params),
		onSuccess: () => {
			message.success(I18n.get('Employee education created successfully!'));
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_PSYCHOSOCIAL_EMPLOYEE_EDUCATION_LIST] });
		},
		onError: () => {
			message.error(I18n.get('Failed to create employee education'));
		},
	});
};
